import SvgIcon from '@material-ui/core/SvgIcon'


export const StreetSvg2 = (props) => (
    <SvgIcon {...props} viewBox="0 0 64 80" color={props.color ? props.color : "primary"} fontSize={props.fontSize ? this.props.fontSize : "large"}>
      <path d="M34 3v7h-4V3H17v58h13v-7h4v7h13V3H34zm0 15.8v8.8h-4v-8.8h4zm-4 26.4v-8.8h4v8.8h-4z"/>
    </SvgIcon>
  );
  
export const PointAddressSvg=(props)=>(
    <SvgIcon {...props} viewBox="0 0 100 125" color="primary" fontSize="large">
    <path d="M52 9h-2C35.6 9 24 19.6 24 35c0 13 17.6 44.6 22.7 53.5.9 1.5 2.4 2.4 4.1 2.4h.2c1.7 0 3.3-.9 4.1-2.4C60.4 79.7 78 48.1 78 35.1 78 19.6 66.3 9 52 9zm-1 39.1c-6.9 0-12.6-5.6-12.6-12.6C38.4 28.6 44.1 23 51 23s12.6 5.6 12.6 12.6c0 6.9-5.7 12.5-12.6 12.5z"/>
       </SvgIcon>
  )
  
export const PolygonSvg=(props)=>(
    <SvgIcon {...props} viewBox="0 0 100 125" color="primary" fontSize="large">
      <path d="M36.019 18.573l16.673 34.111 31.327-14.111-14.207 49.136-34.793 1.864-23-41 24-30M38.071 0L28.21 12.326l-24 30L0 47.588l3.297 5.877 23 41 3.043 5.426 6.213-.333 34.793-1.864 7.098-.38 1.974-6.828 14.207-49.135 6.008-20.779-19.722 8.884L57.42 39.587 45.003 14.182 38.071 0z"/>
    </SvgIcon>
  )
  
  
export const LetterBoxSvg=(props)=>(
    <SvgIcon {...props} viewBox="0 0 69 86.25" color="primary" fontSize="large">
      <path d="M26.525 27.69v20.83c0 .41-.34.75-.75.75H4.705c-.42 0-.75-.34-.75-.75V27.69c0-6.22 5.06-11.28 11.28-11.28 6.319 0 11.29 5.134 11.29 11.28z"/><path d="M65.045 21.97v26.55c0 .41-.33.75-.75.75h-36.4c.08-.23.13-.49.13-.75V27.69c0-4.88-2.75-9.13-6.78-11.28h21.08v10.77c-2.28.9-3.83 3.11-3.83 5.66 0 3.35 2.72 6.08 6.07 6.08s6.08-2.73 6.08-6.08a6.05 6.05 0 00-3.82-5.64V16.41h12.66a5.56 5.56 0 015.56 5.56zM39.845 50.77V65.5c0 .41-.34.75-.75.75h-9.19c-.41 0-.75-.34-.75-.75V50.77h10.69z"/><path d="M61.765 11.78c.2.22.24.54.12.8-.12.27-.39.44-.68.44h-15.88v15.31a4.57 4.57 0 013.82 4.51c0 2.52-2.05 4.58-4.58 4.58-2.52 0-4.57-2.06-4.57-4.58 0-2.28 1.66-4.17 3.83-4.52V3.5c0-.42.33-.75.75-.75h16.63c.29 0 .56.17.68.44s.08.58-.12.8l-3.41 3.9 3.41 3.89z"/>
    </SvgIcon>
  )

// export const What3WordsSvg = () => (
//   <SvgIcon viewBox="0 0 146.273 146.273">
//     <defs><style>.cls-2{fill:#fff}</style></defs>
//     <g>
//       <g>
//         <path d="M117.02 29.252H29.256v87.766h87.766V29.252z" fill="#e11f26" />
//         <path
//           class="cls-2"
//           d="M67.653 92.335a2.745 2.745 0 01-2.603-3.61l10.971-32.913a2.743 2.743 0 015.204 1.736L70.255 90.46a2.743 2.743 0 01-2.602 1.875zM51.197 92.335a2.746 2.746 0 01-2.603-3.61l10.971-32.913a2.743 2.743 0 015.204 1.736L53.8 90.46a2.743 2.743 0 01-2.602 1.875zM84.109 92.335a2.746 2.746 0 01-2.602-3.61l10.97-32.913a2.743 2.743 0 015.204 1.736L86.711 90.46a2.743 2.743 0 01-2.602 1.875z"
//         />
//         <path fill="none" d="M0 0h146.273v146.273H0z" />
//       </g>
//     </g>
//   </SvgIcon>
// );